export const CloseNavIcon = () => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M19 19L12.3959 12.338C12.2024 12.1428 12.2028 11.828 12.3967 11.6332L19 5'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
    />
    <path
      d='M11.9538 19L5.34968 12.338C5.15618 12.1428 5.15652 11.828 5.35043 11.6332L11.9538 5'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
    />
  </svg>
);
